import React from 'react';
import LoadingSpinner from './LoadingSpinner';
import styles from './GlobalLoading.module.css';

export interface GlobalLoadingProps {
  message: string;
  dataTestId?: string;
}

const GlobalLoading: React.FC<GlobalLoadingProps> = ({ message, dataTestId }) => {
  return (
    <output className={styles.overlay} data-test-id={dataTestId} aria-label={message}>
      <div className={styles.spinnerCard}>
        <LoadingSpinner size="medium" />
        <p className={styles.message}>{message}</p>
      </div>
    </output>
  );
};

export default GlobalLoading;
